import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import analytics from '@ktag/styleguide/src/javascripts/analytics/analytics';
import AppContext from 'AppContext';

type EventOptions = {
  listId?: number;
  origin: string;
};

interface Props {
  id?: number;
  showSubscribe?: boolean;
  showEdit?: boolean;
  showUnsubscribe?: boolean;
  showAdditionalInformation?: boolean;
  urlAdditionalInformation?: string;
}

const Actions = ({
  id,
  showSubscribe,
  showEdit,
  showUnsubscribe,
  showAdditionalInformation,
  urlAdditionalInformation,
}: Props) => {
  const { t } = useTranslation('newsletter');
  const { manageBaseUrl, actionsOrigin } = useContext(AppContext);

  const trackEvent = (action: string, options: EventOptions) => {
    analytics.trackEvent('Newsletter', action, options);
  };

  return (
    <div className="actions">
      {showSubscribe && (
        <a
          href={id ? `${manageBaseUrl}#/subscribe/${id}` : `${manageBaseUrl}#/subscribe`}
          className="button button--primary"
          onClick={() =>
            trackEvent('SubscribeStarted', { listId: id, origin: actionsOrigin })
          }
        >
          {t('actions_subscribe')}
        </a>
      )}
      {showEdit && (
        <a
          href={`${manageBaseUrl}#/request-editing`}
          className="button"
          onClick={() => trackEvent('EditStarted', { listId: id, origin: actionsOrigin })}
        >
          {t('actions_edit_profile')}
        </a>
      )}
      {showAdditionalInformation && (
        <a
          href={`${urlAdditionalInformation}`}
          className="button"
          onClick={() =>
            trackEvent('AdditionalInformationStarted', {
              listId: id,
              origin: actionsOrigin,
            })
          }
        >
          {t('actions_additional_information')}
        </a>
      )}
      {showUnsubscribe && (
        <a
          href={`${manageBaseUrl}#/request-unsubscription/${id}`}
          className="button"
          onClick={() =>
            trackEvent('UnsubscribeStarted', { listId: id, origin: actionsOrigin })
          }
        >
          {t('actions_unsubscribe')}
        </a>
      )}
    </div>
  );
};

export default Actions;
